import { format, parseISO } from "date-fns";
import ActionLink from "../../controls/ActionLink";
import { dropdownLabel } from "../../../shared/locationDropdowns";

function formatAmount(value) {
  if (value == null || value === "") return "0";
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return n.toLocaleString("en-US", { maximumFractionDigits: 3 });
}

function formatInvoiceDate(raw) {
  if (!raw) return "";
  try {
    return format(parseISO(String(raw).slice(0, 10)), "MMM d, yyyy");
  } catch {
    return String(raw);
  }
}

export default function PurchaseOrderReceivingPanel({ summary, receivingInvoices = [] }) {
  return (
    <section className="rounded-2xl border border-[#E2E8F0] bg-white p-4 shadow-sm">
      <h2 className="text-sm font-semibold text-[#0F172A]">Receiving progress</h2>

      <p className="mt-3 text-2xl font-bold tabular-nums text-[#0F172A]">
        {formatAmount(summary.received_amount)}{" "}
        <span className="text-base font-medium text-[#64748B]">
          / {formatAmount(summary.ordered_amount)}{" "}
          {summary.unit_of_measure?.label ?? ""}
        </span>
      </p>
      <p className="mt-1 text-sm text-[#64748B]">
        {summary.completion_percent != null
          ? `${summary.completion_percent}% complete`
          : "Quantity received"}
      </p>

      <div className="mt-4 border-t border-[#E2E8F0] pt-4">
        <p className="text-xs font-semibold uppercase tracking-wide text-[#64748B]">
          Receiving invoices
        </p>

        {receivingInvoices.length === 0 ? (
          <p className="mt-2 text-sm text-[#94A3B8]">No receipts yet.</p>
        ) : (
          <ul className="mt-2 space-y-2">
            {receivingInvoices.map((inv) => (
              <li key={inv.id} className="flex items-center justify-between gap-2">
                <div className="min-w-0">
                  <p className="truncate text-sm font-medium text-[#0F172A]">
                    {inv.invoice_number ?? `INV-${inv.id}`}
                  </p>
                  <p className="text-xs text-[#64748B]">
                    {formatInvoiceDate(inv.date)}
                    {inv.location
                      ? ` · ${dropdownLabel(inv.location)}`
                      : ""}
                  </p>
                </div>
                <ActionLink
                  to={`/receiving-invoices/${inv.id}`}
                  variant="soft"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="min-w-0 shrink-0"
                >
                  View
                </ActionLink>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
